<template>
  <div class="app-title-bar py-3 px-4 px-md-8 d-flex align-center justify-space-between"> 
    <div class="title d-flex align-center column-gap-2">
      <slot></slot>
    </div>
    <slot name="actions"></slot>
  </div>
</template>

<style lang="scss">
  .app-title-bar {
    background-color: white;
    border-bottom: 1px solid #e0e0e0;

    .title {
        & h1, & h2, & h3 {
        font-size: 14px !important;
        font-weight: 700;
        line-height: 20px;
      }
    }
  }
</style>